export default [
  {
    path: '/importer',
    name: 'importer',
    component: () => import('@/views/Importer/Importer.vue'),
    meta: {
      title: 'Importers',
      requiresAuth: true,
      action: 'browes',
      resource: 'importer',
      pageTitle: 'Importers',
      breadcrumb: [
        {
          text: 'Importers',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/importer/edit/:id',
    name: 'edit-importer',
    component: () => import('@/views/Importer/control-Importer/AddEditImporter.vue'),
    meta: {
      title: 'Edit Importer',
      requiresAuth: true,
      action: 'edit',
      resource: 'importer',
      pageTitle: 'Importers',
      breadcrumb: [
        {
          text: 'Importers',
          to: '/importer',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
